module.exports = __webpack_public_path__ + "static/media/thomas_weiss_gerbauer_lonfellow.a383e8a7.jpg";